import {Directive, TemplateRef} from '@angular/core'

@Directive({
  selector: '[list-item-header-label]',
  standalone: false,
})
export class FilterListItemHeaderLabelDirective {
  constructor(private tpl: TemplateRef<any>) {}
}
